import { render, staticRenderFns } from "./StackDetail.vue?vue&type=template&id=dbe48098&scoped=true&"
import script from "./StackDetail.vue?vue&type=script&lang=js&"
export * from "./StackDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe48098",
  null
  
)

export default component.exports